export const smoothScroll = (position, speed = 950) => {
  const currentPos = window.scrollY;
  let start = null;
  let progress;

  window.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start;
    progress = currentTime - start;

    if (currentPos < position) {
      window.scrollTo(
        0,
        ((position - currentPos) * progress) / speed + currentPos,
      );
    } else {
      window.scrollTo(
        0,
        currentPos - ((currentPos - position) * progress) / speed,
      );
    }
    if (progress < speed) {
      window.requestAnimationFrame(step);
    } else {
      window.scrollTo(0, position);
    }
  });
};

export const smoothScrollViewport = () => {
  const scrollButtons = document.querySelectorAll('.button--scroll');
  // add spacer for header, since it's fixed
  // (but not on mobile?)
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--header-height',
    ),
  );
  if (scrollButtons.length) {
    scrollButtons.forEach((button) => {
      button.addEventListener('click', () => {
        window.scrollBy({
          top: window.innerHeight - headerHeight,
          left: 0,
          behavior: 'smooth',
        });
      });
    });
  }
};
